import { useState } from "react";
import "./works.scss";

export default function Works() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      title: "Who am I",
      desc:
        "Hello! I'm Carla, I'm 20 years old and I live in Zaragoza, Spain. I like to describe myself as an ambitious, hard-working and highly adaptable person.",
      img:
        "",
    },
    {
      id: "2",
      title: "Student",
      desc:
        "I'm studying 2º year of interior design in ESDA. Since I was young I knew I wanted to do arts high school, and after finishing it I chose interior designing as my passion.",
      img:
        "assets/ESDA.png",
    },
    {
      id: "3",
      title: "Volunteering",
      desc:
        "My other passion is volunteering! Currently, I'm the educator in charge of the children between 8 and 11 years in Grupo 5 Miraflores.",
      img:
        "assets/g5.png",
    },
    {
      id: "4",
      title: "Skating",
      desc:
        "I'm also working as a part-time skating instructor in Skate Faster, teaching children between 5 and 12 years how to skate.",
      img:
        "assets/skate.png",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 3)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };
  
  return (
    <div className="works" id="works">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className="container">
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <center>                  
                    <h2>{d.title}</h2>
                    <p>{d.desc}</p>
                  </center>
                </div>
              </div>
              <div className="right">
                <img
                  src={d.img}
                  alt=""
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt=""
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt=""
        onClick={() => handleClick()}
      />
    </div>
  );
}
